module.exports = "/_next/static/images/top-28ad236fc827c7484daa18440490e279.jpg";